import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import { Button } from '@synergy-marine-group/synergy-ui';
import Header from '../common/Header';
import SubHeader from '../common/SubHeader';
import SearchBar from '../common/SearchBar';
import ButtonComponent from '../common/ButtonComponent';
import VesselCostCentreTable from './VesselCostCentreTable';
import UploadCostCentreModal from './UploadCostCentreModal';
import ConfirmDelete from '../Modal/ConfirmDelete';
import { returnPolicies } from '../../PermissionUtility/ProfilePolicies';
import { resetFilter } from '../../features/fliter/filterSlice';
import { resetVendorFilter } from '../../features/fliter/filterSliceVendor';
import { resetPage } from '../../features/pagecount/pageSlice';
import uploadIcon from '../../images/icons/upload.svg';
import downloadVesselCostCentreTemplate from './queries/downloadVesselCostCentreTemplate';
import deleteVesselCostCentres from './queries/deleteVesselCostCentres';
import showAlert from '../../utils/alert';

const VesselCostCentre = () => {
  const [search, setsearch] = useState('');
  const [pageNumber, setpageNumber] = useState(1);
  const [rowsCount, setrowsCount] = useState(10);
  const [uploadModal, setUploadModal] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const policies = returnPolicies();
  const history = useHistory();
  const dispatch = useDispatch();
  const { mutate: downloadTemplate } = downloadVesselCostCentreTemplate();
  const {
    mutate: deleteItems,
    isSuccess: isDeleteSuccess,
    isError: isDeleteError,
    reset: resetDelete
  } = deleteVesselCostCentres();

  // Single admin policy: page access and manage actions use the same permission
  const canAccessCostCentres = policies?.sapPoAdminPolicies?.canAccess === true;
  const canManageCostCentres = canAccessCostCentres
    || policies?.sapPoAdminPolicies?.canEdit === true;

  const handleSearch = (value) => {
    setsearch(value);
  };

  useEffect(() => {
    dispatch(resetFilter());
    dispatch(resetPage());
    dispatch(resetVendorFilter());
  }, []);

  useEffect(() => {
    if (policies?.sapPoAdminPolicies?.canAccess === false) {
      history.push('/');
    }
  }, [policies]);

  useEffect(() => {
    if (isDeleteSuccess) {
      setDeleteModal(false);
      setSelectedIds([]);
      showAlert('Deleted Successfully', 'success');
      resetDelete();
    }
  }, [isDeleteSuccess]);

  useEffect(() => {
    if (isDeleteError) {
      showAlert('Something went wrong', 'error');
      setDeleteModal(false);
      resetDelete();
    }
  }, [isDeleteError]);

  return (
    <>
      <ToastContainer
        enableMultiContainer
        containerId="cost-centre-toast"
        className="cost-centre-toast-container"
        position="top-right"
        autoClose={false}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      {canAccessCostCentres && (
        <div className="md:w-full vessel-cost-centre-page">
          <Header
            parentPageLink="/"
            currentPage="Cost Centre List"
            headerName="Cost Centres"
          />
          <div className="manning-wrapper">
            <SubHeader
              searchComponent={(
                <SearchBar
                  handleSearch={handleSearch}
                  search={search}
                  placeholder="Search Cost Centre (Minimum 3 characters)"
                  additionalClassName="search-input-width"
                />
              )}
              downloadButton={(
                <>
                  {canManageCostCentres && (
                    <Button
                      type="button"
                      className="max-w-none items-center"
                      onClick={() => setDeleteModal(true)}
                      size="large"
                      variant="outlined"
                      rounded
                      disabled={selectedIds.length === 0}
                    >
                      <div className="flex flex-row font-montserrat text-gray-500 uppercase text-sm items-center">
                        Delete (
                        {selectedIds.length}
                        )
                      </div>
                    </Button>
                  )}
                  {canManageCostCentres && (
                    <ButtonComponent
                      handleClick={() => downloadTemplate()}
                      name="DOWNLOAD TEMPLATE"
                    />
                  )}
                </>
              )}
              addButtonComponent={canManageCostCentres && (
                <ButtonComponent
                  handleClick={() => setUploadModal(true)}
                  name="UPLOAD CSV"
                  icon={uploadIcon}
                />
              )}
            />

            <VesselCostCentreTable
              policies={policies}
              canManage={canManageCostCentres}
              selectedIds={selectedIds}
              setSelectedIds={setSelectedIds}
              search={search}
              pageNumber={pageNumber}
              setpageNumber={setpageNumber}
              rowsCount={rowsCount}
              setrowsCount={setrowsCount}
            />
          </div>

          {uploadModal && (
            <UploadCostCentreModal
              open={uploadModal}
              setOpen={setUploadModal}
            />
          )}

          {deleteModal && (
            <ConfirmDelete
              modal={deleteModal}
              setModal={setDeleteModal}
              handleDelete={() => deleteItems(selectedIds)}
              subMessage={`This will permanently delete ${selectedIds.length} selected cost centre(s).`}
              message="Delete"
            />
          )}
        </div>
      )}
    </>
  );
};

export default VesselCostCentre;
